import { Tabs } from "antd";
import withDashboardLayout from "../../hoc/withDashboardLayout";
import CompletedAppointments from "../../components/admin/appointments/CompletedAppointments";
import InprogressAppointments from "../../components/admin/appointments/InprogressAppointments";
import CancelledAppointments from "../../components/admin/appointments/CancelledAppointments";
import AllAppointments from "../../components/admin/appointments/AllAppointments";
import { useGlobalContext } from "../../context/GlobalProvider";

const Appointments = () => {
  const { appointmentsActiveTab, setAppointmentsActiveTab } =
    useGlobalContext();

  const tabItems = [
    {
      key: "finished",
      label: "Completed",
      children: (
        <CompletedAppointments appointmentsActiveTab={appointmentsActiveTab} />
      ),
    },
    {
      key: "upcoming",
      label: "Upcoming",
      children: (
        <InprogressAppointments appointmentsActiveTab={appointmentsActiveTab} />
      ),
    },
    {
      key: "cancelled",
      label: `Cancelled`,
      children: (
        <CancelledAppointments appointmentsActiveTab={appointmentsActiveTab} />
      ),
    },
    {
      key: "all",
      label: `All`,
      children: (
        <AllAppointments appointmentsActiveTab={appointmentsActiveTab} />
      ),
    },
  ];

  const onTabChange = (key) => {
    setAppointmentsActiveTab(key);
  };

  return (
    <div className="w-full h-full">
      <div className="w-[95%] mx-auto">
        {/* Service Provider Header */}
        <div className="w-full py-4">
          <div className="flex items-center">
            <h2 className="font-semibold title text-lg text-[#000000]">
              Appointments
            </h2>
          </div>
        </div>

        {/* Service Provider */}
        <div className="w-full main-scroll min-h-[calc(100vh-170px)] h-[352px] overflow-scroll flex flex-col gap-y-4 box-shadow rounded-2xl pt-5 bg-white">
          <div className="w-full space-tab">
            <Tabs
              defaultActiveKey={appointmentsActiveTab}
              activeKey={appointmentsActiveTab}
              items={tabItems}
              onChange={onTabChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withDashboardLayout(Appointments);
